import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['addButton', 'removeButton', 'subscription'];

  connect() {
    this.checkDisplayButtonConditions();
  }

  add() {
    const subscription = this.subscriptionTarget.cloneNode(true);
    subscription.querySelector('input').value = null;
    this.subscriptionTargets.slice(-1)[0].after(subscription);
    this.checkDisplayButtonConditions();
  }

  remove(e) {
    e.target.closest("[data-subscription-field-target='subscription']").remove();
    this.checkDisplayButtonConditions();
  }

  checkDisplayButtonConditions() {
    for (let i = 0; i < this.subscriptionTargets.length; i += 1) {
      if (i === this.subscriptionTargets.length - 1) {
        this.subscriptionTargets[i].querySelector("[data-subscription-field-target='addButton']").classList.remove('hidden');
        this.subscriptionTargets[i].querySelector("[data-subscription-field-target='removeButton']").classList.add('hidden');
      } else {
        this.subscriptionTargets[i].querySelector("[data-subscription-field-target='addButton']").classList.add('hidden');
        this.subscriptionTargets[i].querySelector("[data-subscription-field-target='removeButton']").classList.remove('hidden');
      }
    }
  }
}
